import axios from 'axios';
import BaseService from './base.service';
import langUtil from '@/utils/lang.util';
import SettingStorage, { storageLabels } from '@/utils/settings.storage';

const cardsUrl = process.env.VUE_APP_CARDS_API || '';
const folderCardsUrl = process.env.VUE_APP_FOLDER_CARDS_API || '';

export const CardType = {
  'Folder': 'folder',
  'Sound': 'sound',
  'Benefits': 'benefits',
};

export const MediaType = {
  'Video': 'video',
  'MixedGames': 'mixed_games',
}

export const gameType = {
  memory: 'memory',
  puzzle: 'puzzle',
  color: 'color',
  music: 'music',
  hide: 'hide',
  find_the_way: 'find_the_way',
};

export const CardColor = {
  'Red': 'red',
  'Blue': 'blue',
  'Yellow': 'yellow',
  'Green': 'green',
  'Orange': 'orange',
  'Purple': 'purple',
};

export default {
  getApiHeaders() {
    const language = langUtil.getSelectedLanguage();
    const countryCode = localStorage.getItem('kdj_cc') || 'US';
      return { "Accept-Language": `${language}-${countryCode},${language};q=0.9` };
  },
  getCardsList(contentType, offset = 0, limit = 100, filterMask = 0) {
    const age = SettingStorage.getOptionValue(storageLabels.age);

    return BaseService.api(cardsUrl).get('/content/cards', {
      params: { contentType, offset, limit, filterMask, maxAge: age.maxAge, minAge: age.minAge },
      headers: this.getApiHeaders(),
    })
    .then(response => {
      return this.mapCards(response.data.cards);
    })
    .catch(error => {
      console.log(error);
    })
  },
  mapCards(cards) {
    let j = 0;
    const soundPosition = [];
    const soundType = [];
    const cardFilter = cards.filter((x) => [CardType.Folder, CardType.Sound].includes(x.type));

    const cardMap = cardFilter.map((card) => {
      j++;
      if (card.type === CardType.Folder) {
        return {
          identifier: card.id,
          type: card.type,
          mediaType: card.mediaType,
          contentType: card.contentType,
        };
      } else if (card.type === CardType.Sound) {
        soundPosition.push(j - 1);
        let cardSound = '';
        const soundList = ['cow', 'rooster', 'phone', 'car', 'frogs', 'sea'];

        function getRandomInt() {
          return Math.floor(Math.random() * Math.floor(soundList.length - 1));
        }

        if (soundType[soundType.length - 1] === card.sound) {
          cardSound = soundList.includes(card.sound) ? soundList.filter((x) => x !== card.sound)[getRandomInt()] : soundList[getRandomInt()];
        } else {
          cardSound = card.sound;
        }
        soundType.push(cardSound);
        return { type: card.type, sound: cardSound };
      }
    });

    function switchSoundCardPosition(soundCardPosition) {
      for (let k = 1; k < soundCardPosition.length; k++) {
        if ((soundPosition[k - 1] % 2 === soundCardPosition[k] % 2) && (soundPosition[k] !== soundPosition[k - 1] + 1)) {
          insertAndShift(cardMap, soundCardPosition[k]);
          soundCardPosition[k]++;
          switchSoundCardPosition(soundCardPosition);
        }
      }
    }

    function insertAndShift(arr, i) {
      const cutOut = arr.splice(i, 1) [0];
      arr.splice(i + 1, 0, cutOut);
    }

    switchSoundCardPosition(soundPosition);
    return cardMap;
  }, 
  async getCardFolder(identifier) {
    const response = await BaseService.api(folderCardsUrl).get(`/folder/cards/${identifier}`, {
      headers: this.getApiHeaders(),
    });

    const card = response && response.data ? {
      identifier: response.data.id,
      type: response.data.type,
      mediaType: response.data.mediaType,
      contentType: response.data.contentType,
      subCards: [],
    } : {};

    if (card && response && response.data) {
      if (response.data.mediaType === MediaType.Video) {
        response.data.subcards.forEach((subCard) => {
          card.subCards.push({
            identifier: subCard.id,
            type: subCard.type,
            title: subCard.title,
            minAge: subCard.ageMin,
            maxAge: subCard.ageMax,
            duration: subCard.duration,
            premium: subCard.premium,
          });
        });
      } else if (response.data.mediaType === MediaType.MixedGames) {
        response.data.subcards.forEach((subCard) => {
          card.subCards.push({
            identifier: subCard.id,
            gameType: subCard.gameType,
            isLocked: subCard.isLocked,
            position: subCard.position,
          });
        });
      }
    }

    return card;
  },
  async getVideoById(videoId) {
    const response = await BaseService.api(folderCardsUrl).get(`/cards/video/${videoId}`, {
      headers: this.getApiHeaders(),
    });

    return response.data;
  },

  async getSearchData(search) {
    const age = SettingStorage.getOptionValue(storageLabels.age);
    const languageIndex = SettingStorage.getOptionValue(storageLabels.language).value;
    const response = await BaseService.api(cardsUrl).get(
      `/content/cards/search?contentType=` + search.resultType +  
      `&filters=video&details=true&languageId=` + languageIndex +
      `&minAge=` + age.minAge + 
      `&maxAge=` + age.maxAge + 
      `&search=` + search.searchKey, {
      headers: this.getApiHeaders(),
    });
    return response;
  }
};
